import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    const pixelId = '1324305492481406';
    if (typeof window === 'undefined') return;
    const f = window as any;
    const b = document;
    const v = 'https://connect.facebook.net/en_US/fbevents.js';
    if (!f.fbq) {
      const n = (f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      }) as any;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Inject the Facebook events script reliably (works even when no
      // <script> tags are present in the document, e.g. sandboxed iframes).
      const t = b.createElement('script') as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const target = b.head || b.body || b.documentElement;
      target.appendChild(t);
    }
    f.fbq('init', pixelId);
    f.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-151">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1324305492481406&ev=PageView&noscript=1" alt="" data-id="element-152" />
    </noscript>;
}